/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markdown_Render_Error_MessageInputs */

const en_markdown_render_error_message = /** @type {(inputs: Markdown_Render_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This content preview could not be rendered. Try again to reload it.`)
};

const nl_markdown_render_error_message = /** @type {(inputs: Markdown_Render_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze inhoudsweergave kon niet worden geladen. Probeer het opnieuw om opnieuw te laden.`)
};

/**
* | output |
* | --- |
* | "This content preview could not be rendered. Try again to reload it." |
*
* @param {Markdown_Render_Error_MessageInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const markdown_render_error_message = /** @type {((inputs?: Markdown_Render_Error_MessageInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markdown_Render_Error_MessageInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_markdown_render_error_message(inputs)
	return en_markdown_render_error_message(inputs)
});